import {SHOW_NOTIFY} from './index'
export const CHANGE_SUB_SECTION = "change_sub_section";


export var changeSubSection = (section) => {
    return {
        type: CHANGE_SUB_SECTION,
        payload: section
    };
};
export var showNotify = (message) => {
    return{
        type: SHOW_NOTIFY,
        payload: { message }
    };

}


// WEBPACK FOOTER //
// ./resources/assets/js/actions/app.js